exports.DASHBOARDS_EXPORT_PDF = 'Dashboards-Export-PDF';
exports.ENTITY_DELETE = 'Entity-Delete';
exports.BRAND_DELETE = 'Brand-Delete';
exports.CHANNEL_UPSELL_VIEW = 'Channel-Upsell-View';
exports.OFFER_VIEW = 'Offer-View';
exports.REGIONALDASHBOARD_ACCESS = 'RegionalDashboard-Access';
exports.CREATIVES_REPORT_VIEW = 'Creatives-Report-View';
exports.TARGETING_TACTICS_VIEW = 'Targeting-Tactics-View';
exports.SPEND_MARKUP_VIEW = 'Spend-Markup-View';
exports.SOCIAL_DEMOGRAPHICS_REPORT_VIEW = 'Social-Demographics-Report-View';

exports.ADMINAREA_ACCESS = 'AdminArea-Access';

// Dashboard Access
exports.DASHBOARD_ACCESS = 'Dashboard-Access';
exports.DASHBOARD_SOCIAL_VIEW = 'DashboardSocial-View';
exports.DASHBOARD_ADVANCEDTV_VIEW = 'DashboardAdvancedTV-View';
exports.DASHBOARD_YOUTUBE_VIEW = 'DashboardYouTube-View';
exports.DASHBOARD_SITEDIRECT_VIEW = 'DashboardSiteDirect-View';
exports.DASHBOARD_LABS_VIEW = 'DashboardLabs-View';
exports.DASHBOARD_LABS_GEO_VIEW = 'DashboardLabs-Geo-View';
exports.DASHBOARD_LABS_HYPERLOCAL_VIEW = 'DashboardLabs-HyperLocal-View';
exports.DASHBOARD_LABS_RV_VIEW = 'DashboardLabs-RealValue-View';
exports.DASHBOARD_LABS_CC_VIEW = 'DashboardLabs-CrossChannel-View';

// Entity Configuration
exports.ENTITY_CHANNEL_DATASOURCE_EDIT = 'Entity-Channel-Datasource-Edit';
exports.MANAGE_ENTITY_OBJECTIVE = 'Entity-Objective-Management';
exports.ENTITY_OBJECTIVE_EKPI = 'Entity-Objective-eKPI';
exports.ENTITY_UPDATE_V2 = 'Entity-Update-V2';
exports.ENTITY_CREATE_V2 = 'Entity-Create-V2';
exports.ENTITY_OBJECTIVE_LABELCODE_EDIT = 'Entity-Objective-LabelCode-Edit';
exports.LINKEDIN_MAPPING_ACCESS = 'LinkedIn-Mapping-Access';
exports.PINTEREST_MAPPING_ACCESS = 'Pinterest-Mapping-Access';
exports.TWITTER_MAPPING_ACCESS = 'Twitter-Mapping-Access';
exports.DV360_MAPPING_ACCESS = 'Dv360-Mapping-Access';
exports.INNOVID_MAPPING_ACCESS = 'Innovid-Mapping-Access';

// Capability Groups
exports.CAPABILITY_GROUP_CREATE = 'Capability-Group-Create';
exports.CAPABILITY_GROUP_READ = 'Capability-Group-Read';
exports.CAPABILITY_GROUP_UPDATE = 'Capability-Group-Update';
exports.CAPABILITY_GROUP_DELETE = 'Capability-Group-Delete';

// Capability
exports.CAPABILITY_READ = 'Capability-Read';

exports.USER_ALTER_CAP_GROUPS = 'User-Alter-Cap-Groups';
exports.USER_BRAND_ASSOCIATE = 'User-Associate-Brand';
exports.USER_ORGANIZATION_BRANDING_CODE_EDIT = 'User-Organization-Branding-Code-Edit';
exports.USER_UPDATE = 'User-Update';

// Dynamic Profiles
exports.DYNAMIC_PROFILE_CREATE = 'Dynamic-Profile-Create';
exports.DYNAMIC_PROFILE_READ = 'Dynamic-Profile-Read';
exports.DYNAMIC_PROFILE_UPDATE = 'Dynamic-Profile-Update';
exports.DYNAMIC_PROFILE_DELETE = 'Dynamic-Profile-Delete';
exports.DYNAMIC_CREATIVES_REPORT_VIEW = 'Dynamic-Creatives-Report-View';
exports.INNOVID_DYNAMIC_PROFILE = 'Innovid-Dynamic-Profile-Feat';

// Unicorn Permissions
exports.ENTITY_OPPORTUNITY_CREATE = 'Entity-Opportunity-Create';
exports.ENTITY_OPPORTUNITY_UPDATE = 'Entity-Opportunity-Update';

// Whitelabeling
exports.BRAND_WHITELABEL_VIEW = 'Brand-Whitelabel-View';
exports.BRAND_WHITELABEL_UPDATE = 'Brand-Whitelabel-Update';

// Annotations
exports.ANNOTATION_CREATE = 'Annotation-Create';
exports.ANNOTATION_READ = 'Annotation-Read';
exports.ANNOTATION_UPDATE = 'Annotation-Update';
exports.ANNOTATION_DELETE = 'Annotation-Delete';

// Audit
exports.AUDIT_READ = 'Audit-Read';

// G90
exports.G90_HOME_VIEW = 'G90-Home-View';
exports.G90_DEEP_LINKING = 'G90-Deep-Linking';
exports.G90_QA_VIEW = 'G90-QA-View';
exports.FEEDBACK_CREATE = 'Feedback-Create';
exports.FEEDBACK_PROMPT = 'Feedback-Prompt';

// Nav
exports.UNIFIED_NAV_VIEW = 'Unified-Nav-View';

// Analyitcs - Northstar Metrics View
exports.NORTHSTAR_METRICS_VIEW = 'Northstar-Metrics-View';

// Debug
exports.ENTITY_HIERARCHY_DUMP = 'Entity-Hierarchy-Dump';

// Smartguard
exports.SMARTGUARD_SCOREBOARD_VIEW = 'Smartguard-Scoreboard-View';
exports.SMARTGUARD_ADMIN_VIEW = 'Smartguard-Admin-View';
exports.SMARTGUARD_ADMIN_MONITOR_UPDATE = 'Smartguard-Admin-Monitor-Update';

// Custom Channel
exports.CUSTOM_CHANNEL_MODIFY = 'Custom-Channel-Modify';

// Redash Tools
exports.REDASH_TOOLS_DUPLICATE_DASHBOARD = 'Redash-Tools-Duplicate-Dashboard';
exports.REDASH_TOOLS_DUPLICATE_DASHBOARD_QUERIES = 'Redash-Tools-Duplicate-Dashboard-Queries';

// Retail Media Networks
exports.PRODUCT_MANAGER_ADMIN = 'Product-Manager-Admin';

// Pixel QA Site Access
exports.PIXEL_QA_ACCESS = 'Pixel-Qa-Access';

// Campaign Engine Site Access
exports.CAMPAIGN_ENGINE_ACCESS = 'Campaign-Engine-Access';



// WEBPACK FOOTER //
// ./src/constants/capabilities.js